import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import CrearSolicitud from "../modals/CreaSolicitud";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import Consolidado from "./Consolidado";
import SolicitudesApRch from "./SolicitudesAprobadas";
import SolicitudesAprobadasGestor from "./SolicitudesAprobadasGestor";

const cookie = new Cookies();

function InfoSolicitud() {
  const params = useParams();
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [cargado, setCargado] = useState(false);
  const itemsPerPage = 10;

  // 🟩 Paso 1: Autenticación y seteo de cookies
  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: `https://educacionapi.azurewebsites.net/api/AutenticaMicrosoft/${params.id}`,
    })
      .then((response) => {
        const valida = response.data;
        if (valida.length > 0) {
          const respuesta = valida[0];
          cookie.set("id", respuesta.id, { path: "/" });
          cookie.set("Nombre", respuesta.nombre, { path: "/" });
          cookie.set("correo", respuesta.correo, { path: "/" });
          cookie.set("contrasena", respuesta.contrasena, { path: "/" });
          cookie.set("tipo_Usuario", respuesta.tipoUsuario, { path: "/" });
          cookie.set("regional", respuesta.regional, { path: "/" });
          cookie.set("area", respuesta.area, { path: "/" });
          cookie.set("correoGestor", respuesta.correoGestor, { path: "/" });
          cookie.set("gestorAsignado", respuesta.gestorAsignado, { path: "/" });
          setCargado(true); // Marca que ya puede continuar
        } else {
          Swal.fire("Error", "Usuario no válido", "error");
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "No se pudo autenticar el usuario", "error");
      });
  }, [params.id]);

  // 🟨 Paso 2: Validar que haya correo en cookies después de autenticación
  useEffect(() => {
    if (cargado && !cookie.get("correo")) {
      Swal.fire({
        title: "BIENVENIDO",
        text: "Haga clic para continuar",
        icon: "success",
      }).then(() => {
        window.location.href = "/";
      });
    }
  }, [cargado]);

  // 🟦 Paso 3: Mostrar mensaje de bienvenida una vez por sesión
  useEffect(() => {
    if (cargado) {
      const yaMostrado = sessionStorage.getItem("bienvenidaMostrada");
      const nombre = cookie.get("Nombre");

      if (!yaMostrado) {
        Swal.fire({
          title: `¡Bienvenido${nombre ? `, ${nombre}` : ""}!`,
          text: "Gracias por usar la plataforma.",
          icon: "success",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          sessionStorage.setItem("bienvenidaMostrada", "true");
        });
      }
    }
  }, [cargado]);

  // 🟥 Paso 4: Cargar solicitudes dependiendo del tipo de usuario
  useEffect(() => {
    if (!cargado) return;

    const tipoUsuario = cookie.get("tipo_Usuario");
    const correo = cookie.get("correo");
    const id = cookie.get("id");

    let urlendpoint = "";

    if (tipoUsuario == 1 || tipoUsuario == 2) {
      urlendpoint = `https://educacionapi.azurewebsites.net/api/ObtenerPorRegional?regional=${correo}&Estado=Abiertos`;
    } else if (tipoUsuario == 3) {
      urlendpoint = `https://educacionapi.azurewebsites.net/api/ObtenerPorUsuario?idusuario=${id}&Estado=Abiertos`;
    }

    axios
      .get(urlendpoint)
      .then((res) => setList(res.data))
      .catch((error) => console.log(error));
  }, [cargado]);

  // 🔎 Filtro y paginación
  const filteredResults = !search
    ? list
    : list.filter((dato) =>
        dato.nombreCliente?.toLowerCase().includes(search.toLowerCase())
      );

  const totalPages = Math.ceil(filteredResults.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredResults.slice(indexOfFirstItem, indexOfLastItem);

  const tipoUsuario = cookie.get("tipo_Usuario");

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-12">
              <div className="card-header py-12">
                <h6 className="m-0 font-weight-bold text-primary">
                  Solicitudes Propias
                </h6>
                <hr />
              </div>
              <div className="card-body">
                <CrearSolicitud />
                <br />
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Buscar por nombre del cliente"
                  className="form-control"
                />
                <div className="table-responsive mt-3">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre cliente</th>
                        <th>Correo Gestor</th>
                        <th>Estado</th>
                        <th>Vencido</th>
                        <th>Nombre del Comercial</th>
                        <th>Fecha Creación</th>
                        <th>Consultar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center text-muted">
                            No hay resultados
                          </td>
                        </tr>
                      ) : (
                        currentItems.map((item) => {
                          const fecha = new Date(item.fechaCreacion);
                          return (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.nombreCliente}</td>
                              <td>{item.regional}</td>
                              <td>{item.estado}</td>
                              <td>{item.vencido}</td>
                              <td>{item.nombreUsuario}</td>
                              <td
                                className={
                                  item.vencido < 3
                                    ? "text-light bg-warning"
                                    : "text-light bg-danger"
                                }
                              >
                                {fecha.toLocaleDateString("es-CO")}
                              </td>
                              <td>
                                <Consolidado {...item} />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 🔁 Paginación */}
                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    ← Anterior
                  </button>
                  <span className="align-self-center">
                    Página {currentPage} de {totalPages}
                  </span>
                  <button
                    className="btn btn-outline-primary"
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                  >
                    Siguiente →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {tipoUsuario == 3 && <SolicitudesApRch />}
      {(tipoUsuario == 1 || tipoUsuario == 2) && <SolicitudesAprobadasGestor />}
    </Fragment>
  );
}

export default InfoSolicitud;
